import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { CSidebar, CSidebarBrand, CSidebarNav, CSidebarToggler } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'

import { AppSidebarNav } from './AppSidebarNav'

import { logoNegative } from 'src/assets/brand/logo-negative'
import { sygnet } from 'src/assets/brand/sygnet'

import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'

// sidebar nav config
import navigation from '../_nav'
import matchContestNavigation from '../_nav_match_contest'
import adminNavigation from '../_nav_admin'
import CommonService from 'src/service/CommonService'
const adminDetails = JSON.parse(localStorage.getItem('admin'))

const AppSidebar = () => {
  const [gameType, setGameType] = useState()
  const dispatch = useDispatch()
  const unfoldable = useSelector((state) => state.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.sidebarShow)
  useEffect(() => {
    CommonService.getGameType().then((res) => {
      if (res.status === 200) {
        setGameType(res.data)
      }
    })
  }, [])
  return (
    <CSidebar
      colorScheme="light"
      position="fixed"
      unfoldable={unfoldable}
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        dispatch({ type: 'set', sidebarShow: visible })
      }}
    >
      <CSidebarBrand className="d-none d-md-flex" to="/" style={{ backgroundColor: '#1f204e' }}>
        {/* <CIcon className="sidebar-brand-full" icon={logoNegative} height={35} /> */}
        <img
          src="/images/mctlogo1.png"
          alt="logo"
          className="sidebar-brand-full"
          style={{ width: '80%' }}
        />
        <img
          src="/images/mctlogo1.png"
          alt="logo"
          className="sidebar-brand-narrow"
          style={{ width: '80%' }}
        />
        {/* <CIcon className="sidebar-brand-narrow" icon={sygnet} height={35} /> */}
      </CSidebarBrand>
      <CSidebarNav>
        <SimpleBar>
          {adminDetails?.user_role_id !== 1 && gameType === 4 && (
            <AppSidebarNav items={matchContestNavigation} />
          )}
          {adminDetails?.user_role_id !== 1 && gameType !== 4 && (
            <AppSidebarNav items={navigation} />
          )}
          {adminDetails?.user_role_id === 1 && <AppSidebarNav items={adminNavigation} />}
        </SimpleBar>
      </CSidebarNav>
      <CSidebarToggler
        className="d-none d-lg-flex"
        onClick={() => dispatch({ type: 'set', sidebarUnfoldable: !unfoldable })}
      />
    </CSidebar>
  )
}

export default React.memo(AppSidebar)
